import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { PaymentController } from '../../controllers';
import { Spinner, Table, Grid, Button, TextInput, Datepicker } from '../reusable';
import { initialDate, lastDate, paymentTableHeader, withdrawTableHeaeder } from '../../utils/Utils';
import { StyledPayments, StyledPaymentsTable } from './Styles';
import { RouterActions } from '../../redux/actions';
import { Colors } from '../../constants/Colors';
import { search } from '../../assets/images/images';

const Wallet = props => {
  const { saveHistoryOnRedux, setCurrentNav, history } = props;
  const { profile, invoices, getAccountInfo, getInvoices, filterByText, filterByDate } = props;

  const [isFetching, setFetching] = useState(true);

  const fetching = async () => {
    try {
      setFetching(true);

      saveHistoryOnRedux(history);
      setCurrentNav('Recebimentos');

      getAccountInfo(profile.id);

      await getInvoices(profile.id, initialDate, lastDate);

      setFetching(false);
    } catch (err) {}
  };

  useEffect(() => {
    fetching();
  }, []);

  return !isFetching ? (
    <StyledPayments>
      <Grid rows={1} columns={4}>
        <TextInput
          icon={search}
          placeholder={'Buscar'}
          size={'sm'}
          onChange={filterByText}
          onFocus={() => getInvoices(profile.id, initialDate, lastDate)}
        />
        <Datepicker onChange={filterByDate} />
        {/* <Button title={'Gerar relatório financeiro do mês'} backgroundColor={Colors.primary} /> */}
      </Grid>

      <StyledPaymentsTable>
        <Table headers={paymentTableHeader} data={invoices} />
      </StyledPaymentsTable>
    </StyledPayments>
  ) : (
    <Spinner />
  );
};

const mapStateToProps = state => {
  const {
    user: { profile },
    payment: {
      invoicesInfo: { invoices }
    }
  } = state;

  return { profile, invoices };
};

const mapDispatchToProps = dispatch => {
  return {
    getWithdraw: () => dispatch(PaymentController.saveWithdrawInfo()),
    saveHistoryOnRedux: history => dispatch(RouterActions.saveHistory(history)),
    setCurrentNav: current => dispatch(RouterActions.setCurrentRoute(current)),
    getAccountInfo: therapistId => dispatch(PaymentController.fetchAndSaveAccountInfo(therapistId)),
    getSubscriptions: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveSubscriptions(therapistId, initialDate, finalDate)(dispatch),
    getInvoices: (therapistId, initialDate, finalDate) =>
      PaymentController.fetchAndSaveAppointmentsInfo(therapistId, initialDate, finalDate)(dispatch),
    filterByText: text => dispatch(PaymentController.filterPaymentsByText(text)),
    filterByDate: (first, second) => dispatch(PaymentController.filterPaymentsByDate(first, second))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wallet));
